import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { UserVetType } from 'src/app/interfaces/user';

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MM YYYY',
    dateA11yLabel: 'DD/MM/YYYY',
    monthYearA11yLabel: 'MM YYYY',
  },
};

@Component({
  selector: 'app-vet-form',
  templateUrl: './vet-form.component.html',
  styleUrls: ['./vet-form.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'pt-br' },
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ]
})
export class VetFormComponent implements OnInit {

  @Input() user: UserVetType
  @Output() validationEvent = new EventEmitter<boolean>()

  formVet: FormGroup;
  smallScreen: boolean;
  maxDate = new Date();

  constructor(private fb: FormBuilder, private breakpointObserver: BreakpointObserver) {
    this.smallScreen = (window.innerWidth <= 400) ? true : false;
    this.breakpointObserver.observe([
      Breakpoints.XSmall,
      Breakpoints.Small
    ]).subscribe(result => {
      this.smallScreen = result.matches;
    });
  }

  private startForm() {
    this.formVet = this.fb.group({
      nome: [this.user && this.user.nome ? this.user.nome : '', [Validators.required]],
      especie: [(this.user && this.user.especie)],
      raca: [(this.user && this.user.raca)],
      idade: [(this.user && this.user.idade), [Validators.required]],
      sexo: [(this.user && this.user.sexo) || 'm', [Validators.required]],
      gravida: [(this.user && this.user.gravida) || false],
      peso: [(this.user && this.user.peso)],
      castrado: [(this.user && this.user.castrado) || false]
    })
  }

  ngOnInit() {
    this.startForm()
    this.formVet.valueChanges.subscribe(
      changes => {

        // Output, avisar parent da mudança
        this.validationEvent.emit(this.formVet.valid)

        // Se invalido markAsTouch
        if(!this.formVet.valid) {
          this.validation()
        }

      }
    )
  }

  private validation(): void {

    if (this.formVet.invalid) {
      Object.keys(this.formVet.controls).map(
        key => {
          const validationError: ValidationErrors = this.formVet.get(key).errors
          if (validationError != null) {
            Object.keys(validationError).map(
              keyValidation => {
                this.formVet.controls[key].markAsTouched()
              }
            )
          }
        }
      )
    }
  }

  public getValidationForm(): boolean {
    this.validation()
    return this.formVet.valid
  }

  public getUserVet(): UserVetType {
    const _user: UserVetType = this.formVet.value as UserVetType
    _user.idade = this.formVet.get('idade').value ? this.formVet.get('idade').value.toISOString().slice(0, 10) : null

    return _user
  }

}
